import classNames from 'classnames';
import React, {useState} from 'react';
import DangerModal from '../../../components/dangerModal';
import {useAuth} from '../../../context/authContext';
import ProfileMenuItem from './menuItem';

const menuItems: Array<IMenu & {color?: string}> = [
  {
    title: 'آگهی های من',
    icon: 'icon-my-ad',
    route: '/profile/my-ads',
  },
  // {
  //   title: 'نظرات و گزارشات',
  //   icon: 'icon-reports',
  //   route: '/profile/report',
  // },
  {
    title: 'آگهی‌های نشان شده',
    icon: 'icon-bookmark',
    route: '/profile/bookmarks',
  },
  {
    title: 'پشتیبانی',
    icon: 'icon-support',
    route: '/profile/support',
  },
  {
    title: 'درباره مزرعه',
    icon: 'icon-info',
    route: '/profile/about',
  },
  {
    title: 'قوانین و مقررات',
    icon: 'icon-law-page',
    route: '/profile/law',
  },
];

const ProfileMenuItems = () => {
  const [show, setShow] = useState<boolean>(false);
  const {logout} = useAuth();
  const handleClick = () => {
    logout();
  };
  return (
    <>
      <div className="d-flex flex-column px-2">
        {React.Children.toArray(
          menuItems.map(item => <ProfileMenuItem menuItem={item} />),
        )}
        <div
          className="my-3 d-flex align-items-center w-100"
          onClick={() => setShow(true)}
        >
          <i className={classNames('color-danger-red', 'icon-exit_to_app')}></i>
          <small className="pe-3 color-gray-1">خروج از حساب کاربری</small>
        </div>
      </div>
      <DangerModal
        show={show}
        setShow={setShow}
        title="آیا اطمینان به خروج از حساب کاربری خود دارید؟"
        onClick={handleClick}
      />
    </>
  );
};

export default ProfileMenuItems;
